import { render, staticRenderFns } from "./HeaderImg.vue?vue&type=template&id=4107e51b&"
import script from "./HeaderImg.vue?vue&type=script&lang=js&"
export * from "./HeaderImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports